/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.Nobox {

    @Serenity.Decorators.registerClass()
    export class SendEmailDialog extends NoboxEntityDialog<CampaignresultRow, any> {
        protected getFormKey() { return SendEmailForm.formKey; }
        protected getDeletePermission() { return CampaignresultRow.deletePermission; }
        protected getInsertPermission() { return CampaignresultRow.insertPermission; }
        protected getUpdatePermission() { return CampaignresultRow.updatePermission; }

        protected form = new SendEmailForm(this.idPrefix);

        constructor(container?: JQuery) {
            super(container);
            //this.form.BodyText.element.textileToolbar();
            this.form.BodyType.change(() => { 
                var val = this.form.BodyType.get_value();
                if (!Q.isEmptyOrNull(val)) {
                    if (val == "0") {
                        this.form.BodyHtml.getGridField().toggle(false);
                        this.form.BodyText.getGridField().toggle(true);
                        Serenity.EditorUtils.setRequired(this.form.BodyHtml, false);
                        Serenity.EditorUtils.setRequired(this.form.BodyText, true);
                    } else if (val == "1") {
                        this.form.BodyHtml.getGridField().toggle(true);
                        this.form.BodyText.getGridField().toggle(false);
                        Serenity.EditorUtils.setRequired(this.form.BodyHtml, true);
                        Serenity.EditorUtils.setRequired(this.form.BodyText, false);
                    }
                }
            });

            var pageX;
            var pageY;
            $("body").find("ul.tools").remove();
            $("body").append(`<ul class="tools">
                <li title="Italic selected text"><i class="fa fa-italic"></i></li>
                <li title="Bold selected text"><i class="fa fa-bold"></i></li>
                <li title="Strikethrough selected text"><i class="fa fa-strikethrough"></i></li>
                <li title="Monospace selected text">M</li>
            </ul>`);

            $("ul.tools li").eq(0).click(() => {
                this.setCharSelected(this.form.BodyText.element, '_');
                if ($('ul.tools').is(":visible")) {
                    $('ul.tools').fadeOut(200);
                }
            });
            $("ul.tools li").eq(1).click(() => {
                this.setCharSelected(this.form.BodyText.element, '*');
                if ($('ul.tools').is(":visible")) {
                    $('ul.tools').fadeOut(200);
                }
            });
            $("ul.tools li").eq(2).click(() => {
                this.setCharSelected(this.form.BodyText.element, '~');
                if ($('ul.tools').is(":visible")) {
                    $('ul.tools').fadeOut(200);
                }
            });
            $("ul.tools li").eq(3).click(() => {
                this.setCharSelected(this.form.BodyText.element, '```');
                if ($('ul.tools').is(":visible")) {
                    $('ul.tools').fadeOut(200);
                }
            });

            this.form.BodyText.element.bind("mouseup", () => {
                var selectedText = this.getSelected(this.form.BodyText.element);
                if ($('ul.tools').is(":visible")) {
                    $('ul.tools').fadeOut(200);
                } else {
                    if (selectedText != '') {
                        $('ul.tools').css({
                            'left': pageX + 5,
                            'top': pageY - 55
                        }).fadeIn(200);
                    } else {
                        $('ul.tools').fadeOut(200);
                    }
                }
            });
            this.form.BodyText.element.on("mousedown", function (e) {
                pageX = e.pageX;
                pageY = e.pageY;
            });
            if (!Q.isEmptyOrNull($.cookie("AccountEmail"))) {
                Serenity.EditorUtils.setValue(this.form.ProcessBy, $.cookie("AccountEmail"));
            } else {
                var option = <Serenity.ListRequest>{
                    Take: 1,
                    ColumnSelection: 1,
                    IncludeColumns: [AccountRow.Fields.Id],
                    EqualityFilter: {
                        "Channel": 19
                    }
                };
                Q.serviceCall({
                    blockUI: false,
                    url:"/Services/Nobox/Account/List",
                    request: option,
                    onSuccess: (res: Serenity.ListResponse<AccountRow>) => {
                        if (res.Entities.length != 0) {
                            Serenity.EditorUtils.setValue(this.form.ProcessBy, `${res.Entities[0].Id}`);
                        }
                    }
                })
            }


        }

        //public setFromTemplate(res) {
        //    var item = res as CampaignTemplateRow;
        //    if (Q.isEmptyOrNull(this.form.ChannelId.value)) {
        //        Serenity.EditorUtils.setValue(this.form.ChannelId, item.ChannelId);
        //    }
        //    if (Q.isEmptyOrNull(this.form.Attachment.value.toString())) {
        //        Serenity.EditorUtils.setValue(this.form.Attachment, item.Attachment);
        //    }
        //    Serenity.EditorUtils.setValue(this.form.Subject, item.Subject);
        //    Serenity.EditorUtils.setValue(this.form.Body, item.Body);
        //    Serenity.EditorUtils.setValue(this.form.BodyType, item.BodyType);
        //    if (item.BodyType == BodyType.BodyTypeEnum.Text) {
        //        this.form.BodyHtml.getGridField().toggle(false);
        //        this.form.BodyText.getGridField().toggle(true);
        //        this.form.BodyText.value = item.BodyText;
        //        Serenity.EditorUtils.setRequired(this.form.BodyText, true);
        //        Serenity.EditorUtils.setRequired(this.form.BodyHtml, false);
        //    } else if (item.BodyType == BodyType.BodyTypeEnum.HTML) {
        //        this.form.BodyHtml.getGridField().toggle(true);
        //        this.form.BodyText.getGridField().toggle(false);
        //        this.form.BodyHtml.set_value(item.BodyHtml);
        //        Serenity.EditorUtils.setRequired(this.form.BodyHtml, true);
        //        Serenity.EditorUtils.setRequired(this.form.BodyText, false);
        //    }
        //}

        protected updateTitle() {
            this.dialogTitle = "New Email";
        }

        protected getToolbarButtons() {
            var buttons = super.getToolbarButtons();
            buttons[0].title = "Send Now";
            buttons[0].onClick = () => {
                if (this.validateForm()) {
                    Q.serviceCall({
                        service: "/Services/Nobox/Campaignresult/SendEmail",
                        request: this.getSaveRequest(),
                        onCleanup: () => {
                            this.validator && Q.validatorAbortHandler(this.validator);
                        },
                        onSuccess: (res) => {
                            this.dialogClose();
                        }
                    });
                }
            }
            buttons[1].visible = false;
            return buttons;
        }

        getCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts[1] == undefined || parts[1] == "" || parts[1] == null) {
                if (name == "Channel") {
                    return 1;
                } else if (name == "Accounts") {
                    return "";
                }
            } else {
                return parts[1].split(';').shift();
            }
        }

        getSelected(textArea) {
            var text = textArea[0].value;
            var indexStart = textArea[0].selectionStart;
            var indexEnd = textArea[0].selectionEnd;
            return text.substring(indexStart, indexEnd);
        }

        setCharSelected(textArea, char) {
            var text = textArea[0].value;
            var indexStart = textArea[0].selectionStart;
            var indexEnd = textArea[0].selectionEnd;
            var text1 = this.addStr(text, indexStart, char);
            var text2 = this.addStr(text1, indexEnd + char.length, char);
            textArea[0].value = text2;
        }

        addStr(str, index, stringToAdd) {
            return str.substring(0, index) + stringToAdd + str.substring(index, str.length);
        }

        protected updateInterface() {
            super.updateInterface();
            var item = this.get_entity();
            if (this.isEditMode()) {
                if (item.BodyType == 0) {
                    this.form.BodyHtml.getGridField().toggle(false);
                    this.form.BodyText.getGridField().toggle(true);
                    this.form.BodyText.value = item.Body;
                    Serenity.EditorUtils.setRequired(this.form.BodyText, true);
                } else if (item.BodyType == 1) {
                    this.form.BodyHtml.getGridField().toggle(true);
                    this.form.BodyText.getGridField().toggle(false);
                    this.form.BodyHtml.set_value(item.Body);
                    Serenity.EditorUtils.setRequired(this.form.BodyHtml, true);
                    Serenity.EditorUtils.setRequired(this.form.BodyText, false);
                }
            }
        }

        protected save(callback) {
            super.save(callback);
        }
    }
}